import ServerTable from '../components/ServerTable';
import { BrandBadge } from '../brands';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { fetchArchive, ARCHIVE_PAGE_SIZE } from '../store/shownDataSlice';
import * as common from './common';


function ArchiveTable({  }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const data = useSelector((state) => state.shownData.archive);
    const total = useSelector((state) => state.shownData.archiveTotal);

    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [sortKey, setSortKey] = useState('');
    const [sortDir, setSortDir] = useState('');
    const [showAll, setShowAll] = useState(false);
    const brandFilter = useSelector((state) => state.shownData.brandFilter);

    // Start from the first page whenever the brand filter changes
    useEffect(() => { setPage(0); }, [brandFilter]);

    useEffect(() => {
        dispatch(fetchArchive({
            limit: ARCHIVE_PAGE_SIZE,
            offset: page * ARCHIVE_PAGE_SIZE,
            search,
            sortKey,
            sortDir,
            all: showAll,
            brand: brandFilter,
        }));
    }, [page, search, sortKey, sortDir, showAll, brandFilter]);


    return (
        <ServerTable
            style={{ width: '100%' }}
            data={data}
            total={total}
            pageSize={ARCHIVE_PAGE_SIZE}
            page={page}
            search={search}
            sortKey={sortKey}
            sortDir={sortDir}
            showAll={showAll}
            onPageChange={setPage}
            onSearchChange={(text) => { setSearch(text); setPage(0); }}
            onSortChange={(key, dir) => { setSortKey(key); setSortDir(dir); setPage(0); }}
            onToggleShowAll={() => { setShowAll((v) => !v); setPage(0); }}
            columnNames={[
                "Tüüp",
                "Reisi kuupäev",
                "Päringu kuupäev",
                "Firma",
                "Sihtkohad",
                "Reisijad",
                "Vahemaa",
                "Maksumus",
                "Juht",
                "Reisi nr",
            ]}
            serverSortKeys={[
                null,         // Tüüp
                "depart",     // Reisi kuupäev
                "created",    // Päringu kuupäev
                null,         // Firma
                null,         // Sihtkohad
                null,         // Reisijad
                "distance",   // Vahemaa
                "price",      // Maksumus
                "driver",     // Juht
                null,         // Reisi nr
            ]}
            columnRenderers={[
                (row) => (<a onClick={() => navigate("/platform/" + row["type"] + "/" + row["query_id"])}>{common.displayType(row)}</a>),
                (row) => (<p>{common.displayDepart(row)}</p>),
                (row) => (<p>{common.prettifyTimestamp(row["query_created"])}</p>),
                (row) => (<p>{row["query_brand"] === "triobuss" && <><BrandBadge brand={row["query_brand"]} />&nbsp;</>}{row["query_company"] || (<i style={{ color: "#668" }}>{row["query_fullname"]}</i>)}</p>),
                (row) => (<p style={{ maxWidth: 192, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{common.displayPrettyRoute(row)}</p>),
                (row) => (<p>{row["query_passengers"]}</p>),
                (row) => (<p>{common.displayDistance(row)}</p>),
                (row) => (<p>{(["confirmedQuery", "job", "answeredQuery"].includes(row["type"])) ? common.displayPrice(row["query_response_price"]) : '-'}</p>),
                (row) => (<p>{common.displayDriver(row)}</p>),
                (row) => (<p>{row["type"] == "job" ? row["job_sequential_id"] : '-'}</p>),
            ]}
        />
    );
}

export default ArchiveTable;
